import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ItpLauncherComponent} from '@features/scenarios-core/components/itp-luncher/itp-launcher.component';
import {ReactiveFormsModule} from '@angular/forms';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {SharedModule} from '@shared/shared.module';
import {CommandService} from '@core/services/command.service';
import {PlatformApiProvider} from '@shared/services/platform-api-provider';
import {ScenariosHandler} from '@features/scenarios-core/services/handlers/scenarios-handler.service';
import {AddScenarioCommandHandler} from '@features/scenarios-core/services/handlers/add-scenario-command-handler.service';
import {ScenarioDetailsHandler} from '@features/scenarios-core/services/handlers/scenario-detail-handler.service';
import {OpenCalculatorCommandHandler} from '@features/scenarios-core/services/handlers/open-calculator-command-handler.service';
import {ManageEntitiesCommandHandler} from '@features/scenarios-core/services/handlers/manage-entities-command-handler.service';
import {ScenariosDynamicComponentHelper} from '@features/scenarios-core/scenarios-dynamic-component-helper';
import {ManageTransactionsCommandHandler} from '@features/scenarios-core/services/handlers/manage-transactions-command.handler';
import {Pillar2complianceHandler} from '@features/scenarios-core/services/handlers/pillar2compliance-handler.service';
import {
  exactItemsSelectionValidator,
  ValidatorHelper,
  WhiteSpaceValidator
} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/validators-model';
import { ScenarioConfigurationHandler } from './services/handlers/scenario-configuration-handler.service';


@NgModule({
    declarations: [
        ItpLauncherComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule.withConfig({
  callSetDisabledState: 'whenDisabledForLegacyCode',
}),
        MatDatepickerModule,
        MatFormFieldModule,
        SharedModule
    ]
})
export class ScenariosCoreModule {
    constructor(private commandService: CommandService,
                private platformApiProvider: PlatformApiProvider,
                private scenariosHandler: ScenariosHandler,
                private addScenarioCommandHandler: AddScenarioCommandHandler,
                private scenarioDetailsHandler: ScenarioDetailsHandler,
                private openCalculatorCommandHandler: OpenCalculatorCommandHandler,
                private manageEntitiesCommandHandler: ManageEntitiesCommandHandler,
                private manageTransactionsCommandHandler: ManageTransactionsCommandHandler,
                private pillar2complianceHandler: Pillar2complianceHandler,
                private scenarioConfigurationHandler: ScenarioConfigurationHandler) {

        ScenariosDynamicComponentHelper.init();
        ScenariosDynamicComponentHelper.register('ScenariosHandler', scenariosHandler);
        ScenariosDynamicComponentHelper.register('ItcScenariosHandler', scenariosHandler);
        ScenariosDynamicComponentHelper.register('AddScenarioCommandHandler', addScenarioCommandHandler);
        ScenariosDynamicComponentHelper.register('ItcScenarioDetailsHandler', scenarioDetailsHandler);
        ScenariosDynamicComponentHelper.register('ScenarioDetailsHandler', scenarioDetailsHandler);
        ScenariosDynamicComponentHelper.register('OpenCalculatorCommandHandler', openCalculatorCommandHandler);
        ScenariosDynamicComponentHelper.register('ManageEntitiesCommandHandler', manageEntitiesCommandHandler);
        ScenariosDynamicComponentHelper.register('ManageTransactionsCommandHandler', manageTransactionsCommandHandler);
        ScenariosDynamicComponentHelper.register('Pillar2complianceHandler', pillar2complianceHandler);
        ScenariosDynamicComponentHelper.register('ScenarioConfigurationHandler', scenarioConfigurationHandler)
        ValidatorHelper.registerValidator(exactItemsSelectionValidator);
        ValidatorHelper.registerValidator(WhiteSpaceValidator);
    }
}
